// extracted by mini-css-extract-plugin
export default {"PrintWrapper":"PrintOrderDetails_PrintWrapper__o7GHr","ArticleName":"PrintOrderDetails_ArticleName__Vfbdt"};